import { useRef, useState } from "react";
import CustomHook from "./CustomHook";
import AboutSkills from "./AboutSkills";

function Skills() {
  const divs = useRef([]);
  const scrollTab = useRef();
  CustomHook(scrollTab, divs);

  const [listSkills] = useState([
    {
      name: "JavaScript",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
    },
    {
      name: "TypeScript",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
    },
    {
      name: "React",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
    },
    {
      name: "Vue",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
    },
    {
      name: "Pinia",
      icon: "https://pinia.vuejs.org/logo.svg",
    },
    {
      name: "Redux Toolkit",
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg",
    },
  ]);
  return (
    <section className="skills" ref={scrollTab} id="naviki">
      <div className="title" ref={(el) => el && divs.current.push(el)}>
        Лучшие навыки
      </div>
      <div className="list">
        {listSkills.map((value, key) => (
          <div
            className={"item "}
            key={key}
            ref={(el) => el && divs.current.push(el)}
          >
            <img
              src={value.icon}
              width={50}
              height={50}
              alt=""
              fetchpriority="low"
              loading="lazy"
            />
            <h3>{value.name}</h3>
          </div>
        ))}
      </div>
      <AboutSkills />
    </section>
  );
}

export default Skills;
